<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title"><i class="{{isLogin?'fas fa-user-shield': ''}}"></i> {{title}}</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true" (click)="close()">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <span class="custom-span" [hidden]="!isLogin">
               {{"MESSAGE.VERIFICATION-OTP-MSG" | translate}}
            </span>
      <span class="custom-span" [hidden]="isLogin">
               {{"MESSAGE.VERIFICATION-OTP-REGISTER-MSG" | translate }}
            </span>
    </div>
    <br>
    <div *ngIf="showTryAnotherWay">
      <strong>{{"MESSAGE.CHOOSE-SEND-OTP-CODE" | translate}}:</strong>
      <ul class="list-group">
        <li class="list-group-item cursor-pointer" (click)="sendVerificationEmail()">
          <i class="fa fa-envelope text-success"
             aria-hidden="true"></i> {{"MESSAGE.RECEIVE-OTP-VIA-EMAIL" | translate}} <b>{{emailSplited}}</b>
        </li>
        <li class="list-group-item cursor-pointer" *ngIf="isPresentPhoneNumber" (click)="sendVerificationWsp()">
          <i class="fa fa-sms text-success" aria-hidden="true"></i>
          <span [innerHTML]="msgSendWhatsApp"></span>
        </li>
      </ul>
    </div>
    <form [formGroup]="verificationCodeForm">
      <div class="text-justify" *ngIf="!showTryAnotherWay">
        <label class="text-left font-weight-bold">Código verificación (OTP)</label>
        <button class="btn btn-link" [disabled]="enableBtn" (click)="resendCodeOtp()">Reenviar código
        </button>
        {{secondLeft}}s
        <input class="form-control"
               formControlName="codeVerification"
               [maxLength]="6"
               (keypress)="validateFormat($event)"
               placeholder="Escribe el código">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-link" (click)="tryAnotherWay()" *ngIf="!showTryAnotherWay">Probar otra manera</button>
    <button type="button" class="btn btn-success" (click)="confirm()" [disabled]="verificationCodeForm.invalid">
      <i class="fa fa-check-circle" aria-hidden="true"></i> {{'BUTTON.CONFIRM' | translate}}
    </button>
    <button type="button" class="btn btn-danger" data-dismiss="modal"
            (click)="close()">
      <i class="fa fa-times-circle" aria-hidden="true"></i> {{'BUTTON.CANCEL' | translate}}</button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
